// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"SpxGLe","container":"cmPPhy","error":"dGsX55","hover":"exP9Ds"};